import React from 'react';

import { Box, IconV2, SpacingStack, TextV2 } from '@withjoy/joykit';
import { Gift } from '@withjoy/joykit/icons';

import { styles } from './AddressAtoms.style';
import { useTranslation } from '@shared/core';

type LowStockAddressAtomProps = Readonly<{
  coupleName: string;
  hasMultipleGifts: boolean;
}>;

export const LowStockAddressAtom: React.FC<LowStockAddressAtomProps> = ({ coupleName, hasMultipleGifts }) => {
  const { tq } = useTranslation('sharedRegistry');
  return (
    <Box __css={styles.addressAtomLowStockWrapperStyles}>
      <IconV2
        size="sm"
        color="mono14"
        alignSelf="flex-start"
        marginRight={5}
      >
        <Gift />
      </IconV2>
      <SpacingStack spacing={1}>
        <TextV2 typographyVariant="hed1">{hasMultipleGifts ? tq`Your gifts ship straight to ${coupleName}` : tq`This gift ships straight to ${coupleName}`}</TextV2>
        <TextV2
          typographyVariant="label2"
          color="mono12"
        >
          {hasMultipleGifts
            ? tq`One or more items in your cart have limited stock, so your order can only ship to them. Their street address stays private.`
            : tq`It has limited stock, so it can only ship to them. Their street address stays private.`}
        </TextV2>
      </SpacingStack>
    </Box>
  );
};
